import Notify from "config/notify";
import apiClient from "../../../config/apiClient";

const API_LIST_URL = `${process.env.REACT_APP_API_URL}/mst/shipping/dest/select`;
const API_UPDATE_URL = `${process.env.REACT_APP_API_URL}/mst/shipping/dest/update`;
const API_CREATE_URL = `${process.env.REACT_APP_API_URL}/mst/shipping/dest/create`;

/**
 * Handles errors by logging them or sending them to an error tracking service.
 * @param {string} message - The error message.
 * @param {any} error - The error object.
 */
const handleError = (message: string, error: any) => {
  // Replace this with your error handling logic
  console.error(message, error);
};

/**
 * Fetches the list of shipping dest from the API.
 * @returns {Promise<any>} The data from the API response.
 * @throws Will throw an error if the request fails.
 */
const fetchShippingDestApi = async (data: any): Promise<any> => {
  try {
    const response = await apiClient.post(`${API_LIST_URL}`, data);
    return response.data;
  } catch (error) {
    handleError("Error fetching shipping dest:", error);
    throw error;
  }
};

/**
 * Updates a shipping dest using the API.
 * @param {any} data - The data to update the client.
 * @returns {Promise<any>} The data from the API response.
 * @throws Will throw an error if the request fails.
 */
const updateShippingDestApi = async (data: any): Promise<any> => {
  try {
    const response = await apiClient.post(`${API_UPDATE_URL}`, data);
    if (response.status === 200) {
      Notify.setNotification({
        show: true,
        title: data.delete_flag ? "削除しました" : "更新が完了しました",
        confirmLabel: "OK",
        actionsPosition: "center",
      });
    }
    return response.data;
  } catch (error) {
    handleError("Error updating shipping dest:", error);
    throw error;
  }
};

/**
 * Create a shipping dest using the API.
 */
const createShippingDestApi = async (data: any): Promise<any> => {
  try {
    const response = await apiClient.post(`${API_CREATE_URL}`, data);
    if (response.status === 200) {
      Notify.setNotification({
        show: true,
        title: "新規登録しました",
        confirmLabel: "OK",
        actionsPosition: "end",
      });
    }
    return response.data;
  } catch (error) {
    handleError("Error create shipping dest:", error);
    throw error;
  }
};

export { fetchShippingDestApi, updateShippingDestApi, createShippingDestApi };
